import { type Routes } from '@angular/router';

import { authGuard, guestGuard } from '@core/guards';

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'users',
    pathMatch: 'full',
  },
  {
    path: 'auth',
    canMatch: [guestGuard],
    loadComponent: () => import('../layouts').then((layout) => layout.AuthLayout),
    loadChildren: () => import('./auth/auth.routes').then((m) => m.authRoutes),
  },
  {
    path: 'users',
    canMatch: [authGuard],
    loadComponent: () => import('../layouts').then((layout) => layout.DefaultLayout),
    loadChildren: () => import('./users/users.routes').then((m) => m.usersRoutes),
  },
  {
    path: 'feedback',
    canMatch: [authGuard],
    loadComponent: () => import('../layouts').then((layout) => layout.DefaultLayout),
    children: [
      {
        path: '',
        loadComponent: () => import('../pages/feedback').then((m) => m.FeedbackPage),
      },
    ],
  },
  {
    path: '**',
    redirectTo: 'users',
  },
];
